import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IDualControlDetail } from '../../interfaces/configuration/dual-control-detail.interface';
import { IDualControlCount } from '../../interfaces/configuration/dual-control-count.interface';

export abstract class AbstractConfigurationReviewStatusService extends ITableService {
  abstract getDetail(id: number): Promise<IDualControlDetail | undefined>;
  abstract getCount(): Promise<IDualControlCount | undefined>;
}
